import React, { useState } from "react";
import styled from "styled-components";
import { UserIcon } from "../../atoms/icons/sidebar/UserIcon";
import { Button } from "../../atoms/Button";
import { COLOR_LIGHT_BLUE, COLOR_WHITE, COLOR_PRIMARY } from "../../../constants/color";
import { useNavigation } from '../../../hooks/useNavigation';
import { SignOutModal } from "../../organisms/modal/SignOutModal";

type Props = {
  username: string;
  handleLogout: () => void;
  selectedMenuPath?: string;
  onMobileClose?: () => void;
};

export const SidebarFooter: React.FC<Props> = ({
  username,
  handleLogout,
  selectedMenuPath,
  onMobileClose,
}) => {
  const { navigateToPage } = useNavigation();
  const isSelected = selectedMenuPath === '/account';

  const handleAccountClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigateToPage('/account');
    // Close mobile sidebar when Account is clicked
    if (onMobileClose) {
      onMobileClose();
    }
  };

  const [showDialog, setShowDialog] = useState(false);
  const handleSignOutClick = () => setShowDialog(true);
  const handleCancel = () => setShowDialog(false);
  const handleConfirm = () => {
    setShowDialog(false);
    handleLogout();
  };

  return (
    <StyledFooterContainer>
      <StyledAccountContainer $isSelected={isSelected} onClick={handleAccountClick}>
        <UserIcon fillColor={isSelected ? '#0A3D91' : '#fff'} />
        <StyledAccountText $isSelected={isSelected}>Account</StyledAccountText>
      </StyledAccountContainer>
      <StyledButtonContainer>
        <Button text={"Sign Out"} variant={"border"} onClick={handleSignOutClick} />
      </StyledButtonContainer>
      <SignOutModal open={showDialog} onCancel={handleCancel} onConfirm={handleConfirm} />
    </StyledFooterContainer>
  );
};

const StyledFooterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

const StyledAccountContainer = styled.div<{ $isSelected: boolean }>`
  display: flex;
  width: 248px;
  height: 48px;
  padding: 0 10px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background-color: ${({ $isSelected }) =>
    $isSelected ? COLOR_LIGHT_BLUE : COLOR_PRIMARY};
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background-color: ${COLOR_LIGHT_BLUE};
  }

  @media (max-width: 768px) {
    width: 240px;
    height: 52px;
    padding: 0 15px;
    gap: 12px;
  }
`;

const StyledAccountText = styled.div<{ $isSelected: boolean }>`
  color: ${({ $isSelected }) => ($isSelected ? COLOR_PRIMARY : COLOR_WHITE)};
  font-size: 14px;
  font-weight: 500;
  line-height: 100%;

  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 600;
  }
`;

const StyledButtonContainer = styled.div`
  margin-top: 20px;
  button {
    width: 268px;
    display: flex;
  }

  @media (max-width: 768px) {
    margin-top: 25px;
    button {
      width: 260px;
      height: 48px;
      font-size: 16px;
      font-weight: 600;
    }
  }
`